import React, { createContext, useContext, useState, useEffect } from 'react';
import { getLanguage, setLanguage as setLangStorage, languages } from '../utils/i18n';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [currentLang, setCurrentLang] = useState(getLanguage());

    const setLanguage = (lang) => {
        setLangStorage(lang);
        setCurrentLang(lang);
        // Force re-render by dispatching custom event
        window.dispatchEvent(new CustomEvent('languageChanged', { detail: lang }));
    };

    useEffect(() => {
        const handleLanguageChange = () => {
            setCurrentLang(getLanguage());
        };

        window.addEventListener('languageChanged', handleLanguageChange);
        return () => window.removeEventListener('languageChanged', handleLanguageChange);
    }, []);

    return (
        <LanguageContext.Provider value={{ currentLang, setLanguage, languages }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};


